import EventBus from "./event-bus";
import {errorHandler} from "./common";

const axios = require('axios');
export function getCreditOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/creditOrder?orderId=' + orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateCreditOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/creditOrder', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function queryCreditOrders(query) {
  return new Promise(function (resolve, reject) {
    console.log("query order "+ query)
    axios.get(process.env.ROOT_API + 'admin/creditOrders?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function invoiceCreditOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("issue credit note ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/creditOrder/invoice?orderId='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log("credit note issued");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function sendInvoiceCreditOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("Send Invoice ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/creditOrder/send/invoice?orderId='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);

      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}
export function completeCreditOrder(orderId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/creditOrder/complete?orderId='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item completed");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function cancelCreditOrder(orderId) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/creditOrder/cancel?orderId='+orderId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item Cancelled");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteCreditOrder(id) {
  return new Promise(function (resolve, reject) {
    // console.log("query order "+ query)
    console.log("delete item " + id);
    axios.delete(process.env.ROOT_API + 'admin/creditOrder?orderId=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("delete response");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        errorHandler(error);
        reject(error)
      });
  })
}
export function createCreditOrder(itemId, quantity, type) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/creditOrder/orderItem/' + itemId + '/create/' + quantity + '/' + type, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Order Item Cancelled");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/creditOrder.js